import { AbstractTokenService } from './abstract-token.service';
import { defer, of } from 'rxjs';
import { SessionService } from './session.service';
import { Uuid } from '../utils/uuid.utils';
import { oauthLogger } from '../utils/logging.utils';
import { handleErrorStatus } from '../utils/response.utils';
import { getCachedJwt, removeCachedJwt, setCachedJwt } from '../utils/store.util';
import { getAccessToken } from '../utils/oam.util';
import { LoginCookieService } from './login-cookie.service';
export class JwtTokenService extends AbstractTokenService {
  constructor(sessionService = new SessionService()) {
    super();
    this.sessionService = sessionService;
    // Soll zukünftig aus dem JWT Claim "exp" bezogen werden, um die gültigkeit des Tokens zu prüfen
    this.JWT_EXPIRATION_TIME = 3600;
  }
  /**
   * JWT von OAM holen
   * Wenn JWT noch im Cache @token wird dieses JWT geliefert
   * Wenn BaHttpConfig nicht gesetzt oder in BaHttpConfig der oamHost undefined/null/leer ist wird null geliefert
   * Bei einem Fehler wird null geliefert
   *
   * @param config
   */
  fetchToken(config) {
    const jwt = getCachedJwt();
    if (jwt != null) {
      oauthLogger.info('Es wurde ein gültiger OAM-Token im Cache gefunden. Die Authorisierungsanfrage ist nicht mehr notwendig.');
      this.sessionService.initJwt(jwt, config);
      return of(jwt);
    }
    oauthLogger.info('OAM-Token wird ermittelt.');
    return defer(() => fetch(JwtTokenService.getOAMUrl(config.oamHost, config.jwtResourceUrl), {
      credentials: 'include',
    })
      .then((response) => handleErrorStatus(response))
      .then((response) => {
      const accessToken = getAccessToken(response.url);
      if (accessToken == null || accessToken === 'null' || accessToken === '') {
        // BaLoginSession cookie aktualisieren
        LoginCookieService.setLoginCookie(LoginCookieService.LoginStatus.LOGGEDOUT);
        return Promise.reject(new Error('OAM Token wurde in der Antwort nicht gefunden!'));
      }
      // BaLoginSession cookie aktualisieren (vor schreiben in cache damit isValidTokenSession korrekt funktioniert)
      LoginCookieService.setLoginCookie(LoginCookieService.LoginStatus.LOGGEDIN);
      const token = { access_token: accessToken, expires_in: this.JWT_EXPIRATION_TIME };
      oauthLogger.info('JWT wird als URL Parameter [access_token] geliefert und im Cache gesetzt.');
      setCachedJwt(token);
      return token.access_token;
    })
      .then((value) => {
      this.sessionService.initJwt(value, config);
      return value;
    }));
  }
  appendOptions(token, finalOptions) {
    const headers = finalOptions.headers;
    oauthLogger.info('OAM-Token wurde ermittelt und wird dem Request hinzugefügt.');
    headers.set(JwtTokenService.HEADER_NAME_AUTHORIZATION, 'Bearer ' + token);
    finalOptions.headers = headers;
    return finalOptions;
  }
  static getOAMUrl(host, jwtResourceUrl) {
    const defaultResource = '/oauth2/rest/authz?domain=ba&client_id=BAPublicClient';
    // Port darf nicht gesetzt sein am host der redirect_uri (OAM liefert sonst einen 400 und invalid redirect_uri)
    const hostNoPort = host.replace(/:\d+/, '');
    const additionalParameter = '&response_type=token' + '&redirect_uri=' + encodeURIComponent(hostNoPort + '/sso/gettoken_ig?cb=true') + '&scope=OAG.jwt' + '&state=' + Uuid.uuid();
    // resourceUrl gesetzt? Ansonsten default Wert verwenden
    const resUrl = jwtResourceUrl && jwtResourceUrl.length > 0 ? jwtResourceUrl : defaultResource;
    // handle missing slash in config
    if (!host.endsWith('/') && !resUrl.startsWith('/') && !resUrl.startsWith('?')) {
      host += '/';
    }
    // jwt generator? -> keine zusätzlichen Query Parameter da diese am Apache zu einem 404 führen
    if (host.match(/jwt-generator/i) || resUrl.match(/jwt-generator/i)) {
      return host + resUrl;
    }
    return host + resUrl + additionalParameter;
  }
  resetToken() {
    removeCachedJwt();
  }
  resetBy(_config) {
    this.resetToken();
  }
}
JwtTokenService.HEADER_NAME_AUTHORIZATION = 'Authorization';
//# sourceMappingURL=jwt-token.service.js.map
